import * as moment from 'moment';
import { UtilService } from 'src/app/services/util/util.service';
import { Player } from './player.model';

export class Profile {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.appUserID = json && json.app_user_id || null;
        this.jersey = json && json.jersey || null;
        this.position = json && json.position || null;
        this.description = json && json.description || null;
        this.twitterUrl = json && json.twitter_url || null;
        this.facebookUrl = json && json.facebook_url || null;
        this.instagramUrl = json && json.instagram_url || null;
        this.birthdate = json && json.birthdate || null;
        this.positionName = json && json.position_name || null;
        this.leagueRNID = json && json.league_rnid || null;
        this.street = json && json.street || null;
        this.city = json && json.city || null;
        this.provinceRNID = json && json.province_rnid || null;
        this.postal = json && json.postal || null;
        this.countryRNID = json && json.country_rnid || null;
        this.height = json && json.height || null;
        this.weight = json && json.weight || null;
        this.shot = json && json.shot || null;
        this.catch = json && json.catch || null;
        this.showBirthdate = json && json.show_birthdate || null;
        this.headshot = json && json.headshot || null;
        this.uploadedHeadshot = json && json.uploaded_headshot || null;
        this.primaryTeamName = json && json.primary_team_name || null;
        this.primaryTeamNameShort = json && json.primary_team_short_name || null;
        this.hometown = json && json.hometown || null;
        this.birthplace = json && json.birthplace || null;
        this.nationality = json && json.nationality || null;
        this.primaryTeamRNID = json && json.primary_team_rnid || null;

        this.isSkater = (json && json.is_skater != null) ? json.is_skater : null;

        if(this.birthdate) {
            this.momentBirthdate = moment.utc(this.birthdate);
        }

        this.age = 0;
        if(this.momentBirthdate) {
            this.age = moment().diff(this.momentBirthdate, 'years');
        }
    }

    id: number;
    appUserID: number;
    jersey: number;
    position: number;
    description: string;
    twitterUrl: string;
    facebookUrl: string;
    instagramUrl: string;
    birthdate: string;
    positionName: string;
    leagueRNID: number;
	street: string;
	city: string;
	provinceRNID: number;
	postal: string;
	countryRNID: number;
	height: string;
	weight: string;
    shot: string;
    catch: string;
    showBirthdate: boolean;
	headshot: string;
    uploadedHeadshot: string;
    isSkater: boolean | null;
    primaryTeamName: string;
    primaryTeamNameShort: string;
    hometown: string;
    birthplace: string;
    nationality: string;
    primaryTeamRNID: number;

    momentBirthdate: moment.Moment;
    age: number;

    toJSON() {
        return {
            id: this.id,
            app_user_id: this.appUserID,
            jersey: this.jersey,
            position: this.position,
            description: this.description,
            twitter_url: this.twitterUrl,
            facebook_url: this.facebookUrl,
            instagram_url: this.instagramUrl,
            birthdate: this.birthdate,
            position_name: this.positionName,
            league_rnid: this.leagueRNID,
            street: this.street,
            city: this.city,
            province_rnid: this.provinceRNID,
            postal: this.postal,
            country_rnid: this.countryRNID,
            height: this.height,
            weight: this.weight,
            shot: this.shot,
            catch: this.catch,
            headshot: this.headshot,
            uploaded_headshot: this.uploadedHeadshot,
            primary_team_name: this.primaryTeamName,
            primary_team_short_name: this.primaryTeamNameShort,
        }
    }

    toPlayerInformation(): Player {
        let playerInfo: Player = new Player();

        playerInfo.shot = this.shot;
        playerInfo.catch = this.catch;
        playerInfo.hometown = this.hometown;
        playerInfo.birthPlace = this.birthplace;
        playerInfo.height = UtilService.instance.heightToInches(this.height);
        playerInfo.weight = +this.weight;
        playerInfo.birthDate = this.momentBirthdate;
        playerInfo.jerseyNumber = this.jersey;
        playerInfo.countryLongName = this.nationality;
        playerInfo.isSkater = this.isSkater;
        playerInfo.primaryTeamRNID = this.primaryTeamRNID;
        playerInfo.primaryTeamName = this.primaryTeamName;
        playerInfo.age = this.age;
        playerInfo.headshot = this.headshot;
        playerInfo.position = this.positionName;

        return playerInfo;
    }    
}